__webpack_require__.p = "/wp-content/themes/garofoli/dist/scripts/";